import { select, put } from "redux-saga/effects";
import { setUserSelectedAccountCode } from "../../../app/appActions";
import {
    getUserAccounts,
    getUserSelectedAccountCode,
    getIsAppVisibility,
    getUserDefaultAccountCode
} from "../../../app/appSelectors";
import { getLiteTradeAssetsAction } from "../../../modules/LiteTrade/liteTradeActions";
import { getLiteTradeSessionToken } from "../../../modules/LiteTrade/liteTradeSelectors";
import parseAccountName from "../../../utils/parseAccountName";
import _ from "lodash";


// бизнесс логика из useLiteTradeWssEvents
export function* setSelectedAccountSaga() {
    const accounts = yield select(getUserAccounts);
    const defaultAccountCode = yield select(getUserDefaultAccountCode);
    const selectedAccountCode = yield select(getUserSelectedAccountCode);
    if (accounts.length && selectedAccountCode) {
        if (!_.find(accounts, { name: selectedAccountCode })) {
            localStorage.removeItem('selectedAccount');
            yield put(setUserSelectedAccountCode(null));
        }
    }
    if (accounts.length && !selectedAccountCode) {
        const selectedAccountInMem = localStorage.getItem('selectedAccount');
        const foundSelectedAccountInMem = _.find(accounts, { name: selectedAccountInMem });
        const foundDefaultAccount = _.find(
            accounts,
            (accountItem) => defaultAccountCode === parseAccountName(accountItem.name)?.accountCode,
        );
        yield put(
            setUserSelectedAccountCode(
                foundSelectedAccountInMem?.name || foundDefaultAccount?.name || accounts[0].name,
            ),
        );
    }
}


export function* getLiteTradeAssetsSaga() {
    const selectedAccountCode = yield select(getUserSelectedAccountCode);
    const sessionToken = yield select(getLiteTradeSessionToken);
    const isAppVisibility = yield select(getIsAppVisibility);
    if (selectedAccountCode && isAppVisibility && sessionToken) {
        yield put(getLiteTradeAssetsAction());
    }
}
